/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <kpa@giap.pl>, May 2021
 */
import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './NotFound.css';

class EPUAPCertNotFound extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  render() {
    return (
      <div className={s.root}>
        <div className={s.container}>
          {this.props.title ? <h1>{this.props.title}</h1> : null}
          <div
            className={s.napis}
          >
          Wybrany Urząd nie posiada niezbędnego do działania usługi certyfikatu ePUAP lub certyfikat stracił ważność.
          Prosimy o kontakt z Urzędem.
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(EPUAPCertNotFound);



// WEBPACK FOOTER //
// src/routes/ePUAPNotFound/ePUAPCertNotFound.js